import { dataFetch } from '@lib/ggj-utils'

export default {
  // 希柔一级协议列表
  async getProtocolList(params) {
    return dataFetch('/shop-home-web/protocol/shero/list', params, {
        method: 'post',
        headers: {
          'Content-Type': 'application/json'
        }
    })
  },
	///protocol/ssyh/list
	async getSSYHList(params) {
		return dataFetch('/shop-home-web/protocol/ssyh/list', params, {
			method: 'post',
			headers: {
				'Content-Type': 'application/json'
			}
		})
	},

  async getSecProtocolList(params) {
    return dataFetch('/shop-home-web/protocol/shero/sec/list/' + params.id, {}, {
        method: 'post',
        headers: {
          'Content-Type': 'application/json'
        }
    })
  },
	async getSecProtocolListSSYH(params) {
		return dataFetch('/shop-home-web/protocol/ssyh/sec/list/' + params.id, {}, {
			method: 'post',
			headers: {
				'Content-Type': 'application/json'
			}
		})
	},
  async getProtocolDetail(params) {
    return dataFetch('/shop-home-web/protocol/sec/detail/' + params.id, {}, {
        method: 'post',
        headers: {
          'Content-Type': 'application/json'
        }
    })
  }
}

